module.exports = __webpack_public_path__ + "media/images/gallery/constellations/lyra/lyr_names-bfe37b771fbb3b9aca3eab204f7412dd.gif";